const renderContent = (value, row, index) => {
  const obj = {
    children: value,
    attrs: {}
  }
  if (index === 4) {
    obj.attrs.colSpan = 0
  }
  return obj
}

export const tableCol = [
  {
    key: 'caseNumber',
    title: 'Case Number',
    dataIndex: 'caseNumber',
    scopedSlots: { customRender: 'caseNumber' },
    align: 'left',
    width: 'auto'
  },
  {
    key: 'lvoCaseSubType',
    title: 'Case Type',
    dataIndex: 'caseType',
    scopedSlots: { customRender: 'caseType' },
    align: 'left',
    width: 'auto',
    sorter: true
  },
  {
    key: 'deliveryNum',
    title: 'Delivery Number',
    dataIndex: 'deliveryNum',
    scopedSlots: { customRender: 'deliveryNum' },

    align: 'left',
    width: 'auto',
    sorter: true
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    align: 'left',
    width: 'auto',
    scopedSlots: { customRender: 'status' },

    sorter: true
  },
  {
    key: 'updateTime',
    title: 'Last Update Time',
    dataIndex: 'updateTime',
    align: 'left',
    width: 'auto',
    scopedSlots: { customRender: 'updateTime' },
    sorter: true
  },
  {
    key: 'operation',
    title: 'Operation',
    scopedSlots: { customRender: 'edit' },
    align: 'left',
    width: '180px'
  }
]

export const RequestConfig = {
  DCG: [
    {
      name: 'Delivery Refusal by Customer',
      code: '1'
    },
    {
      name: 'Extra Costs From Carrier,Extra Service',
      code: '2'
    },
    {
      name: 'Shipment is Damaged',
      code: '3'
    },
    {
      name: 'EDI Missing',
      code: '4'
    },
    {
      name: 'Customer Contact Detail Request',
      code: '5'
    },
    {
      name: 'Incorrect Address',
      code: '6'
    },
    {
      name: 'MFG Packing list Request',
      code: '7'
    },
    {
      name: 'Request for Missing Information',
      code: '8'
    }
  ],
  IDG: [
    {
      name: 'Customer Contact Details Request',
      code: '9'
    },
    {
      name: 'Customer Deferral Help Request',
      code: '10'
    },
    {
      name: 'Delivery Refusal by Customer',
      code: '11'
    },
    {
      name: 'EDI Missing',
      code: '12'
    },
    {
      name: 'Extra Costs from Carrier,Extra Service',
      code: '13'
    },
    {
      name: 'Invoice Missing',
      code: '14'
    },

    {
      name: 'Packing List Request',
      code: '16'
    },
    {
      name: 'Shipment is Damaged',
      code: '17'
    }, {
      name: 'Other',
      code: '15'
    }
  ]
}
